import { useState } from "react";
import {
  RequestCreateInboundPlansRequest,
  AmazonInboundPlansPostRequest,
  AmazonApi,
  ResponseCreateInboundPlanResponse,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiRegisterInboundPlan = () => {
  const [resultRegister, setResultRegister] = useState<boolean>(false);
  const [result, setResult] = useState<ResponseCreateInboundPlanResponse>({});
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const registerInboundPlan = async (req: RequestCreateInboundPlansRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: AmazonInboundPlansPostRequest = {
        req,
      };

      const api = new AmazonApi(config);
      const response = await api.amazonInboundPlansPost(request);
      setResult(response);
      return response;
    } catch (err: any) {
      const message =
        err?.response?.data?.error ??
        "プランの登録に失敗しました（不明なエラー）";
      setError(message);
      console.error(err);
      console.error(message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { registerInboundPlan, resultRegister, error, setError, isLoading };
};
